import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/pages/Home";
import Footer from "./components/footer/Footer";
import TermAndCondition from "./components/termandcondition/TermAndCondition";
import NotFoundPage from "./components/pages/NotFoundPage";
import PrivacyPolicy from "./components/privacypolicy/PrivacyPolicy";
import Test from "./components/pages/Test";
import AboutUs from "./components/aboutUs/AboutUs";
import OurService from "./components/ourService/OurService";
import ContactUs from "./components/contactUs/ContactUs";
import { NavBar } from "./components/navBar/NavBar";
import Project from "./components/projects/Project";
import ProjectDetailPage from "./components/projects/ProjectDetailPage";
import ServiceDetailPage from "./components/ourService/ServiceDetailPage";
import { servicelistdata } from "./components/assets/servicelistdata";
import OurTeam from "./components/ourTeam/OurTeam";
import FAQs from "./components/faqs/FAQs";
import serviceList from "./components/assets/serviceList";
import Blog from "./components/blogs/Blog";





function App() {
  return (
<div className="font-kumbh pt-16">
  
  <NavBar/>
  <Routes>
    <Route path="/"  element={<Home/>} />
    <Route path="/about-us"  element={<AboutUs/>} />
    <Route path="/our-services"  element={<OurService/>} />
    {/* <Route path="/services/:serviceId" element={<ServiceDetailPage services={servicelistdata} />}/> */}
    
    <Route
  path="/services/:serviceId"
  element={<ServiceDetailPage />}
 />

    <Route path="/portfolio-grid"  element={<Project/>} />
    <Route path="/portfolio-grid/:portfolioId" element={<ProjectDetailPage />} />
    <Route path="/blog"  element={<Blog/>} />
    <Route path="/contact-us"  element={<ContactUs/>} />
    <Route path="/terms-and-conditions"  element={<TermAndCondition/>} />
    <Route path="/privacy-policy"  element={<PrivacyPolicy/>} />
    <Route path="/faqs"  element={<FAQs/>} />
    <Route path="/our-team-members"  element={<OurTeam/>} />

    <Route path="/test"  element={<Test/>} />

    <Route path="*" element={<NotFoundPage />} />
  </Routes>
<Footer/>
  
</div>
  );
}

export default App;
